<template>
  <div>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <h4 class="d-flex align-items-center">
        <font-awesome-icon class="mr-50" icon="fa-solid fa-chart-simple" />
        <span class="ml-1"
          >{{ newProgressData.id > 0 ? "編輯" : "新增" }}進度資料</span
        >
      </h4>
      <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-form class="mt-3" @submit.prevent="handleSubmit(onSubmit)" key="2">
          <div class="mt-2 mt-sm-3 position-relative">
            <b-row>
              <!-- Progress id -->
              <b-col cols="12" md="6">
                <b-form-group
                  label="進度編號："
                  label-for="id"
                  label-cols-md="3"
                  class="align-items-center"
                >
                  <div class="">
                    {{
                      newProgressData.project_progress_number
                        ? newProgressData.project_progress_number
                        : "系統自動生成"
                    }}
                  </div>
                </b-form-group>
              </b-col>

              <!-- order_number -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_order_number"
                >
                  <b-form-group
                    label="施工單號："
                    label-for="order_number"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="order_number"
                      v-model="newProgressData.order_number"
                      placeholder="輸入施工單號"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12">
                <hr />
              </b-col>

              <!-- project_id -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_project_id"
                >
                  <b-form-group
                    label="項目："
                    label-for="progress_project_id"
                    label-cols-md="3"
                    class="required"
                  >
                    <v-select
                      id="progress_project_id"
                      v-model="newProgressData.project_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="projectOptions"
                      :clearable="false"
                      label="project_name"
                      :reduce="(option) => option.id"
                      placeholder="選擇項目"
                      :filter="projectSearch"
                    >
                      <template #option="{ project_number, project_name }">
                        [{{ project_number }}] {{ project_name }}
                      </template>
                      <template
                        #selected-option="{ project_number, project_name }"
                      >
                        [{{ project_number }}] {{ project_name }}
                      </template>
                    </v-select>
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- pay_date -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_pay_date"
                >
                  <b-form-group
                    label="支付日期："
                    label-for="pay_date"
                    label-cols-md="3"
                  >
                    <flat-pickr
                      v-model="newProgressData.pay_date"
                      class="form-control"
                      :config="{
                        allowInput: true,
                        altInput: true,
                        altFormat: 'Y-m-d',
                        dateFormat: 'Y-m-d',
                      }"
                      placeholder="輸入YYYY-MM-DD"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <b-col cols="12" md="12">
                <div
                  class="d-flex flex-wrap flex-md-nowrap align-items-center full_input"
                >
                  <label>項目名稱</label>
                  <div class="input_wrap">
                    <validation-provider
                      #default="validationContext"
                      name="此欄"
                      rules="required"
                      vid="v_project_name"
                    >
                      <b-form-input
                        id="c_project_name"
                        v-model="newProgressData.project_name"
                        placeholder="輸入項目名稱"
                        :state="getValidationState(validationContext)"
                      />
                      <b-form-invalid-feedback>
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </div>
                </div>
              </b-col>

              <!-- project_address -->
              <b-col cols="12" md="12">
                <div
                  class="d-flex flex-wrap flex-md-nowrap align-items-center full_input"
                >
                  <label>工程地址：</label>
                  <div class="input_wrap">
                    <validation-provider
                      #default="validationContext"
                      name="此欄"
                      rules="required"
                      vid="v_project_address"
                    >
                      <b-form-input
                        id="c_address"
                        v-model="newProgressData.project_address"
                        placeholder="輸入工程地址"
                        :state="getValidationState(validationContext)"
                      />
                      <b-form-invalid-feedback>
                        {{ validationContext.errors[0] }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </div>
                </div>
              </b-col>
            </b-row>
            <hr />
            <!-- 工資 -->
            <h5 class="mb-3">成本摘要</h5>
            <div>
              <p class="mb-2 d-flex justify-content-between">
                <span>工資</span
                ><b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="success"
                  @click="addItem('salary_items')"
                  size="sm"
                >
                  <feather-icon size="16" icon="PlusCircleIcon" />
                </b-button>
              </p>
              <b-row
                v-for="(worker, index) in newProgressData.salary_items"
                :key="`worker_${index}`"
                class="px-1"
              >
                <b-col
                  cols="12"
                  class="d-flex backgroundColor5 mb-1 radius-round border-1"
                >
                  <b-row class="flex-grow-1 p-2">
                    <!-- worker -->
                    <b-col cols="12" md="6">
                      <b-row>
                        <b-col cols="12">
                          <validation-provider
                            #default="validationContext"
                            :vid="`v_worker_id${index}`"
                            :name="`此欄(${index + 1})`"
                            rules="required"
                          >
                            <b-form-group
                              :label="`師傅(${index + 1})：`"
                              :label-for="`worker_id${index}`"
                              label-cols-md="2"
                              class="required"
                            >
                              <v-select
                                v-model="worker.worker_id"
                                :dir="
                                  $store.state.appConfig.isRTL ? 'rtl' : 'ltr'
                                "
                                :options="workerOptions"
                                :clearable="false"
                                label="name_cn"
                                :reduce="(option) => option.id"
                                placeholder="選擇師傅"
                                @input="(val) => changePosition(worker, val)"
                              >
                              </v-select>
                              <b-form-invalid-feedback
                                :state="getValidationState(validationContext)"
                              >
                                {{ validationContext.errors[0] }}
                              </b-form-invalid-feedback>
                            </b-form-group>
                          </validation-provider>
                        </b-col>

                        <!-- position -->
                        <b-col cols="12">
                          <validation-provider
                            #default="validationContext"
                            :vid="`v_worker_position${index}`"
                            name="此欄"
                            rules="required"
                          >
                            <b-form-group
                              label="職位"
                              :label-for="`worker-position${index}`"
                              label-cols-md="2"
                              class="required"
                            >
                              <b-form-input
                                :id="`worker-position${index}`"
                                v-model="worker.position"
                                :state="getValidationState(validationContext)"
                                placeholder="輸入職位"
                              />
                              <b-form-invalid-feedback>
                                {{ validationContext.errors[0] }}
                              </b-form-invalid-feedback>
                            </b-form-group>
                          </validation-provider>
                        </b-col>

                        <!-- salary -->
                        <b-col cols="12">
                          <b-row class="mb-1 cal-input-group">
                            <!-- postpone_date -->
                            <b-col md="2" class="label"> 工資: </b-col>
                            <b-col md="10" class="c_content">
                              <div
                                class="content-wrapper d-flex align-items-center"
                              >
                                <validation-provider
                                  #default="validationContext"
                                  :vid="`v_working_days${index}`"
                                  name="此欄"
                                  rules="required"
                                >
                                  <b-input-group
                                    class="group1 w-100"
                                    size="md"
                                    append="日"
                                  >
                                    <b-form-input
                                      id="working_days"
                                      v-model="worker.working_days"
                                      placeholder="輸入工作日數"
                                      @input="calTotalSalary(worker)"
                                      :state="
                                        getValidationState(validationContext)
                                      "
                                    />
                                  </b-input-group>
                                </validation-provider>

                                <div class="operator">*</div>

                                <validation-provider
                                  #default="validationContext"
                                  :vid="`v_worker_day_salary${index}`"
                                  name="此欄"
                                  rules="required"
                                >
                                  <b-input-group
                                    class="group2 w-100"
                                    size="md"
                                    prepend="$"
                                    append="每日"
                                  >
                                    <b-form-input
                                      :id="`worker_day_salary${index}`"
                                      v-model="worker.day_salary"
                                      placeholder="輸入每日工資"
                                      @input="calTotalSalary(worker)"
                                      :state="
                                        getValidationState(validationContext)
                                      "
                                    />
                                  </b-input-group>
                                </validation-provider>

                                <div class="operator">=</div>

                                <b-input-group
                                  class="group3"
                                  size="md"
                                  prepend="$"
                                >
                                  <b-form-input
                                    id=""
                                    disabled
                                    type="number"
                                    v-model="worker.total_salary"
                                    placeholder="0"
                                    class="bg-white"
                                  />
                                </b-input-group>
                              </div>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                    <!-- working_date -->
                    <b-col cols="12" md="6">
                      <b-row>
                        <b-col cols="12">
                          <validation-provider
                            #default="validationContext"
                            :vid="`v_worker_working_date${index}`"
                            name="此欄"
                            rules="required"
                          >
                            <b-form-group
                              label="開工日期"
                              :label-for="`worker-working_date${index}`"
                              label-cols-md="2"
                              class="required"
                            >
                              <b-form-textarea
                                :id="`worker-working_date${index}`"
                                v-model="worker.working_date"
                                rows="4"
                                :state="getValidationState(validationContext)"
                                placeholder="輸入開工日期"
                              />
                              <!-- <flat-pickr
                            v-model="newProgressData.working_date"
                            class="form-control"
                            :config="{
                              mode: 'multiple',
                              allowInput: true,
                              altInput: true,
                              altFormat: 'Y-m-d',
                              dateFormat: 'Y-m-d',
                            }"
                            placeholder="輸入YYYY-MM-DD"
                          /> -->

                              <b-form-invalid-feedback>
                                {{ validationContext.errors[0] }}
                              </b-form-invalid-feedback>
                            </b-form-group>
                          </validation-provider>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <div
                    class="d-flex flex-column justify-content-between py-50 px-25"
                  >
                    <feather-icon
                      size="16"
                      icon="PlusIcon"
                      class="cursor-pointer text-success"
                      @click="addItem('salary_items', index)"
                    />
                    <feather-icon
                      size="16"
                      icon="XIcon"
                      class="cursor-pointer text-danger"
                      @click="removeItem('salary_items', index, worker.id)"
                    />
                  </div>
                </b-col>
              </b-row>
            </div>
            <hr />
            <!-- 其他成本 -->
            <div>
              <p class="mb-2 d-flex justify-content-between">
                <span>其他成本</span
                ><b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="success"
                  @click="addItem('cost_items')"
                  size="sm"
                >
                  <feather-icon size="16" icon="PlusCircleIcon" />
                </b-button>
              </p>
              <b-row
                v-for="(cost, index) in newProgressData.cost_items"
                :key="`cost_${index}`"
                class="px-1"
              >
                <b-col
                  cols="12"
                  class="d-flex backgroundColor3 mb-1 radius-round border-1"
                >
                  <b-row class="flex-grow-1 p-2">
                    <!-- product id -->

                    <b-col cols="12" md="6">
                      <b-row>
                        <b-col cols="12">
                          <validation-provider
                            #default="validationContext"
                            :vid="`v_product_id${index}`"
                            :name="`此欄(${index + 1})`"
                            rules="required"
                          >
                            <b-form-group
                              :label="`商品(${index + 1})：`"
                              :label-for="`product_id${index}`"
                              label-cols-md="2"
                              class="required"
                            >
                              <v-select
                                v-model="cost.product_id"
                                :dir="
                                  $store.state.appConfig.isRTL ? 'rtl' : 'ltr'
                                "
                                :options="productOptions"
                                :clearable="false"
                                label="product_name"
                                :reduce="(option) => option.id"
                                placeholder="選擇商品"
                              >
                              </v-select>
                              <b-form-invalid-feedback
                                :state="getValidationState(validationContext)"
                              >
                                {{ validationContext.errors[0] }}
                              </b-form-invalid-feedback>
                            </b-form-group>
                          </validation-provider>
                        </b-col>

                        <b-col cols="12">
                          <b-row class="mb-1 cal-input-group">
                            <!--  -->
                            <b-col md="2" class="label"> 金額: </b-col>
                            <b-col md="10" class="c_content">
                              <div
                                class="content-wrapper d-flex align-items-center"
                              >
                                <validation-provider
                                  #default="validationContext"
                                  :vid="`v_cost_quantity${index}`"
                                  name="此欄"
                                  rules="required"
                                >
                                  <b-input-group
                                    class="group1 w-100"
                                    size="md"
                                    :append="getProduct(cost.product_id).unit"
                                  >
                                    <b-form-input
                                      id="cost-quantity"
                                      type="number"
                                      v-model="cost.quantity"
                                      placeholder="輸入數量"
                                      @input="calTotalCost(cost)"
                                      :state="
                                        getValidationState(validationContext)
                                      "
                                    />

                                    <!-- @input="(val) => calculatePostponeDate(val)" -->
                                  </b-input-group>
                                </validation-provider>

                                <div class="operator">*</div>
                                <validation-provider
                                  #default="validationContext"
                                  :vid="`v_cost_unit_price${index}`"
                                  name="此欄"
                                  rules="required"
                                >
                                  <b-input-group
                                    class="group2 w-100"
                                    size="md"
                                    prepend="$"
                                    :append="`每${
                                      getProduct(cost.product_id).unit
                                    }`"
                                  >
                                    <b-form-input
                                      :id="`cost_unit_price${index}`"
                                      v-model="cost.unit_price"
                                      placeholder="輸入單價"
                                      @input="calTotalCost(cost)"
                                      :state="
                                        getValidationState(validationContext)
                                      "
                                    />
                                  </b-input-group>
                                </validation-provider>

                                <div class="operator">=</div>

                                <b-input-group
                                  class="group3"
                                  size="md"
                                  prepend="$"
                                >
                                  <b-form-input
                                    id=""
                                    class="cost_amount"
                                    disabled
                                    type="number"
                                    v-model="cost.amount"
                                    placeholder="輸入總金額"
                                  />
                                </b-input-group>
                              </div>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>

                    <b-col cols="12" md="6">
                      <b-row>
                        <!-- item_description -->
                        <b-col cols="12">
                          <b-form-group
                            label="備註："
                            :label-for="`cost-item_description${index}`"
                            label-cols-md="2"
                            class=""
                          >
                            <b-form-textarea
                              :id="`cost-item_description${index}`"
                              v-model="cost.item_description"
                              rows="4"
                              placeholder="輸入備註"
                            />
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <div
                    class="d-flex flex-column justify-content-between py-50 px-25"
                  >
                    <feather-icon
                      size="16"
                      icon="PlusIcon"
                      class="cursor-pointer text-success"
                      @click="addItem('cost_items', index)"
                    />
                    <feather-icon
                      size="16"
                      icon="XIcon"
                      class="cursor-pointer text-danger"
                      @click="removeItem('cost_items', index, cost.id)"
                    />
                  </div>
                </b-col>
              </b-row>
            </div>
            <hr />
            <b-row class="justify-content-end">
              <!-- <b-col cols="12" md="6" class="" v-if="in_approve">
                <validation-provider
                  #default="validationContext"
                  name="審批狀態"
                  rules="required"
                >
                  <b-form-group
                    label="審批狀態："
                    label-for="approve_status_id"
                    label-cols-md="3"
                    class="required"
                  >
                    <v-select
                      id="approve_status_id"
                      v-model="newProgressData.approve_status_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="approvalStatusOptions"
                      :clearable="false"
                      label="name"
                      :reduce="(option) => option.id"
                      placeholder="審批狀態"
                    >
                    </v-select>
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col> -->
              <!-- order_number -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_total_amount"
                >
                  <b-form-group
                    label="薪金支出："
                    label-for="total_amount"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="total_amount"
                      class="bg-white"
                      :value="newProgressData.total_amount"
                      :disabled="true"
                      placeholder="0"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>

            <hr />

            <upload-file-single
              v-on:file-uploaded="onFileUploaded"
            ></upload-file-single>

            <hr />
          </div>

          <div class="d-flex mt-1 flex-wrap flex-lg-nowrap justify-content-end">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-sm-2 mobile-w100"
              type="submit"
            >
              <feather-icon size="16" class="mr-1" icon="CheckCircleIcon" />
              提交
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
              class="mt-1 mt-sm-0 mobile-w100"
            >
              取消
            </b-button>
          </div>
        </b-form>
      </b-overlay>
    </validation-observer>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BFormTextarea,
  BInputGroup,
  BButton,
  BOverlay,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { ref, watch } from "@vue/composition-api";
import vSelect from "vue-select";
import store from "@/store";
import Ripple from "vue-ripple-directive";
import "animate.css";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
localize("zh_cn", zh_CN);
import formValidation from "@core/comp-functions/forms/form-validation";
import { required, email } from "@validations";
import uploadFileSingle from "@/layouts/components/file/uploadFileSingle.vue";

export default {
  data() {
    return {
      required,
      dragAndDropCapable: false,
    };
  },
  directives: {
    Ripple,
  },
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormFile,
    BFormInvalidFeedback,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BFormTextarea,
    BInputGroup,
    BRow,
    BCol,
    BButton,
    BOverlay,
    flatPickr,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    uploadFileSingle,
  },
  methods: {
    projectSearch(options, search){
      var returnOptions = options.filter(item => {
        return item.project_number.toLowerCase().includes(search.toLowerCase()) || item.project_name.toLowerCase().includes(search.toLowerCase())
      })
        return returnOptions
    },
    calculateTotalAmount() {
      let total = 0;
      for (let i = 0; i < this.newProgressData.cost_items.length; i++) {
        total += parseFloat(this.newProgressData.cost_items[i].amount);
      }

      for (let i = 0; i < this.newProgressData.salary_items.length; i++) {
        total += parseFloat(this.newProgressData.salary_items[i].total_salary);
      }
      this.newProgressData.total_amount = total;
    },
    changePosition(worker, val) {
      let position =
        this.workerOptions &&
        this.workerOptions.find((item) => item.id == val).position;
      worker.position = position;
    },
    hide() {
      this.$router.replace("/progress/list");
    },
    onFileUploaded(file) {
      this.newProgressData.documents = file;
    },
    onSubmit() {
      // if (this.newProgressData.id == 0 && this.newProgressData.file) return;
      if (
        this.newProgressData.salary_items.length +
          this.newProgressData.cost_items.length <=
        0
      ) {
        this.makeToast(
          "danger",
          "Warning",
          "請輸入最少一個工資或其他成本記錄。"
        );
        return;
      }

      this.$swal({
        title: "你確定嗎?",
        text: "你確定提交資料嗎？",
        showCancelButton: true,
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          let formData = new FormData();

          formData.append("id", this.newProgressData.id);
          formData.append("order_number", this.newProgressData.order_number);
          formData.append("project_id", this.newProgressData.project_id);
          formData.append(
            "project_address",
            this.newProgressData.project_address
          );
          formData.append("project_name", this.newProgressData.project_name);
          formData.append("pay_date", this.newProgressData.pay_date);

          for (let i = 0; i < this.newProgressData.salary_items.length; i++) {
            for (let key of Object.keys(this.newProgressData.salary_items[i])) {
              formData.append(
                `salary_items[${i}][${key}]`,
                this.newProgressData.salary_items[i][key]
              );
            }
          }
          for (let i = 0; i < this.newProgressData.cost_items.length; i++) {
            for (let key of Object.keys(this.newProgressData.cost_items[i])) {
              formData.append(
                `cost_items[${i}][${key}]`,
                this.newProgressData.cost_items[i][key]
              );
            }
          }

          formData.append("expenditure", this.newProgressData.total_amount);

          if (this.newProgressData.documents) {
            if (this.newProgressData.documents.size >= 2097152) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Error! Your Image size is larger then 2M",
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              });
              return false;
            } else {
              formData.append("documents[]", this.newProgressData.documents);
            }
          }

          // if (this.newProgressData.file) {
          //   if (this.newProgressData.file.size >= 2097152) {
          //     this.$toast({
          //       component: ToastificationContent,
          //       props: {
          //         title: "Error! Your Image size is larger then 2M",
          //         icon: "AlertTriangleIcon",
          //         variant: "danger",
          //       },
          //     });
          //     return false;
          //   } else {
          //     formData.append("file", this.newProgressData.file);
          //   }
          // }

          this.loading = true;
          store
            .dispatch("progress/editProgress", formData)
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.hide();
              this.$emit("refetch-data");
              // if (this.newProgressData.id == 0) {
              //   this.newProgressData.id = response.data.id;
              //   this.redirect(response.data.id);
              // }
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    makeToast(variant = null, title = null, content = null) {
      this.$bvToast.toast(content, {
        title: title,
        variant,
        solid: true,
      });
    },

    addItem(key, index) {
      const newItem = JSON.parse(JSON.stringify({ id: 0 }));
      this.newProgressData[key].splice(index + 1, 0, newItem);
    },
    removeItem(key, index, id) {
      // check number of record
      let record =
        this.newProgressData &&
        this.newProgressData[key] &&
        this.newProgressData[key].length;
      if (record <= 1 && false) {
        this.makeToast("danger", "Warning", "請至少留有一個表單。");
      } else {
        if (id > 0) {
          this.$swal({
            title: "你確定嗎?",
            text: "您的行動是最終的，您將無法檢索這記錄。",
            showCancelButton: true,
            confirmButtonText: "刪除",
            cancelButtonText: "取消",
            customClass: {
              confirmButton: "btn btn-primary",
              cancelButton: "btn btn-outline-danger ml-1",
            },
            buttonsStyling: false,
          }).then((result) => {
            if (result.value) {
              let url = "deleteProgressSalary";
              if (key == "cost_items") url = "deleteProgressCost";
              store
                .dispatch(`progress/${url}`, { id })
                .then((response) => {
                  this.$swal({
                    text: response.data.message,
                    icon: "success",
                    confirmButtonText: "確定",
                    customClass: {
                      confirmButton: "btn btn-primary",
                    },
                    showClass: {
                      popup: "animate__animated animate__bounceIn",
                    },
                    buttonsStyling: false,
                  });
                  this.$emit("refetch-data");
                })
                .catch((error) => {
                  this.$swal({
                    text: error.response.data.message,
                    icon: "error",
                    confirmButtonText: "確定",
                    customClass: {
                      confirmButton: "btn btn-primary",
                    },
                    showClass: {
                      popup: "animate__animated animate__bounceIn",
                    },
                    buttonsStyling: false,
                  });
                });
            }
          });
        } else {
          this.newProgressData[key].splice(index, 1);
        }
      }
      this.updateTotalAmount();
    },
    formatTimeWithoutHMS(time) {
      let newt = new Date(time),
        month,
        day,
        hour,
        min,
        sec;
      month = newt.getMonth() + 1;
      month = month < 10 ? "0" + month : month;

      day = newt.getDate();
      day = day < 10 ? "0" + day : day;

      return `${newt.getFullYear()}-${month}-${day}`;
    },
  },
  props: {
    progressData: {
      type: Object,
      required: true,
    },
    projectOptions: {
      type: Array,
      required: true,
    },
    productOptions: {
      type: Array,
      required: true,
    },
    workerOptions: {
      type: Array,
      required: true,
    },
    approvalStatusOptions: {
      type: Array,
      required: true,
    },
  },

  setup(props, { emit }) {
    const newProgressData = ref({
      id: 0,
      salary_items: [{ id: 0 }],
      cost_items: [{ id: 0 }],
    });

    const trigger = ref(false);
    watch(
      () => props.progressData,
      (newVal) => {
        newProgressData.value = { ...newVal };
      }
    );

    watch(
      () => newProgressData.value.project_id,
      (newVal) => {
        if (
          props.projectOptions &&
          props.projectOptions.length > 0 &&
          newProgressData.value.id == 0
        ) {
          newProgressData.value.project_address = props.projectOptions.filter(
            (ele) => ele.id == newVal
          )[0].address;

          newProgressData.value.project_name = props.projectOptions.filter(
            (ele) => ele.id == newVal
          )[0].project_name;

          trigger.value = !trigger.value;
        }
      }
    );
    const getProduct = (id) => {
      if (id) {
        const obj =
          props.productOptions &&
          props.productOptions.length > 0 &&
          props.productOptions.filter((ele) => ele.id == id)[0];
        return { ...{ unit: "次" }, ...obj };
      } else {
        return { unit: "次" };
      }
    };
    const calTotalSalary = (item) => {
      if (item.working_days && item.day_salary) {
        item.total_salary = Number(item.working_days) * Number(item.day_salary);
      }
      updateTotalAmount();
    };
    const calTotalCost = (item) => {
      if (item.quantity && item.unit_price) {
        item.amount = Number(item.quantity) * Number(item.unit_price);
      }
      updateTotalAmount();
    };

    const updateTotalAmount = () => {
      let total_amount = 0;

      total_amount += Number(
        newProgressData.value.salary_items.reduce(
          (total, item) => total + item.total_salary,
          0
        )
      );

      total_amount += Number(
        newProgressData.value.cost_items.reduce(
          (total, item) => total + item.amount,
          0
        )
      );

      newProgressData.value.total_amount = total_amount || 0;
    };

    const resetProgressData = () => {
      newProgressData.value = JSON.parse(
        JSON.stringify({
          id: 0,
          salary_items: [{ id: 0 }],
          cost_items: [{ id: 0 }],
        })
      );
    };

    const loading = ref(false);

    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetProgressData);

    return {
      loading,
      refFormObserver,
      getValidationState,
      resetForm,
      newProgressData,
      getProduct,
      calTotalSalary,
      calTotalCost,
      updateTotalAmount,
      trigger,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>

<style lang="scss" scoped>
</style>
